import { create } from 'zustand';

type CanvasVersionTargetBarDismissedState = {
  dismissedKeys: string[];
  dismiss: (key: string) => void;
  /** A draft is keyed by its open key until commit gives it a canvas id. */
  rekey: (fromKey: string, toKey: string) => void;
};

/**
 * Page-load memory for the Back pill, per canvas. Dismiss does not remove the link or the version target.
 */
export const useCanvasVersionTargetBarDismissedStore = create<CanvasVersionTargetBarDismissedState>()((set) => ({
  dismissedKeys: [],
  dismiss: (key) =>
    set((state) => (state.dismissedKeys.includes(key) ? state : { dismissedKeys: [...state.dismissedKeys, key] })),
  rekey: (fromKey, toKey) =>
    set((state) =>
      state.dismissedKeys.includes(fromKey)
        ? { dismissedKeys: [...state.dismissedKeys.filter((key) => key !== fromKey), toKey] }
        : state,
    ),
}));
